export const saasHeroScreens = [
  {
    id: 'growth',
    label: 'Growth',
    type: 'copilot',
    title: 'Copilot',
    subtitle: 'Company Brain · live',
    copilot: [
      { role: 'user', text: 'Which cohort is churning fastest?' },
      { role: 'assistant', text: 'Meta broad trials: 23 flagged. Save sequence ready.' },
      { role: 'assistant', text: 'MRR +$8.5k net. Expansion led.' },
    ],
    suggestions: ['Approve sequence', 'View cohort'],
    metrics: [
      { label: 'MRR', value: '$84.2k', change: '+12%', positive: true },
      { label: 'Trials', value: '412', change: '+18%', positive: true },
    ],
  },
  {
    id: 'waste',
    label: 'Ads',
    type: 'ads',
    title: 'Waste Alert',
    subtitle: 'Meta + Google · 30d',
    metrics: [
      { label: 'Waste', value: '$4.2k', change: '3 ads', positive: false },
      { label: 'ROAS', value: '1.8×', change: '↓ 0.4', positive: false },
    ],
    campaigns: [
      { name: 'Meta · Broad US', waste: '$1.8k', bar: 92, action: 'Pause' },
      { name: 'Google · Display', waste: '$1.4k', bar: 78, action: 'Trim 40%' },
    ],
    insight: 'Move $800/wk to branded search.',
    actionLabel: 'Review',
  },
  {
    id: 'onboarding',
    label: 'Onboard',
    type: 'onboard',
    title: 'Onboarding',
    subtitle: 'Day 1–14 sequence',
    metrics: [
      { label: 'Complete', value: '68%', change: '+11%', positive: true },
      { label: 'Stuck', value: '89', change: 'Nudged', positive: null },
    ],
    steps: [
      { label: 'Welcome', pct: 94 },
      { label: 'Connect stack', pct: 72 },
      { label: 'First value', pct: 68 },
    ],
    insight: 'A/B test queued for step 3 drop-off.',
    actionLabel: 'Open flow',
  },
  {
    id: 'support',
    label: 'Support',
    type: 'support',
    title: 'Inbox',
    subtitle: '12m avg response',
    tickets: [
      { subject: 'Billing question', status: 'Replied', tone: 'resolved', time: '2m' },
      { subject: 'Seat limit on Pro', status: 'Review', tone: 'open', time: '8m' },
      { subject: 'Export failed', status: 'Escalated', tone: 'pending', time: '14m' },
    ],
    metrics: [
      { label: 'Open', value: '4', change: '↓ 2', positive: true },
      { label: 'CSAT', value: '4.8', change: '+0.2', positive: true },
    ],
    agentNote: '12 resolved overnight',
  },
  {
    id: 'retain',
    label: 'Retain',
    type: 'retain',
    title: 'Retention',
    subtitle: 'Churn watch',
    metrics: [
      { label: 'At risk', value: '31', change: '↓ 9', positive: true },
      { label: 'Saved', value: '$12k', change: 'ARR', positive: true },
    ],
    accounts: [
      { name: 'Acme Corp', plan: 'Pro', risk: 'High', mrr: '$890' },
      { name: 'Bright Labs', plan: 'Pro', risk: 'High', mrr: '$1.2k' },
    ],
    insight: '3 saves before cancel today.',
    actionLabel: 'Save queue',
  },
];

export const saasHeroFloatIntegrations = [
  { name: 'Meta', image: '/integrations/instagram.webp', alt: 'Meta' },
  { name: 'Google', image: '/integrations/google_ads.png', alt: 'Google Ads' },
  { name: 'Gmail', image: '/integrations/gmail.png', alt: 'Gmail' },
];
